<coin-v2-dialog-frame
  [header]="data.headline | translate"
  (closeButtonClick)="close()">
  <div class="body-container">
    <ng-template documentUploadDialogDirective></ng-template>
  </div>
</coin-v2-dialog-frame>
